/**
 * Các loại trạng thái biên bản kiểm tra
 */
export default {
  /**
   * Đang kiểm tra
   */
  Checking: 10,
  /**
   * Gửi trả
   */
  Return: 15,
  /**
  * Đã hoàn thành
  */
  Complete: 20,
  /**
   * Cấp dưới yêu cầu thu hồi
   */
  RequestRevoke: 25,

   /**
     * đang xử lý
     */
   ProcessReturn: 30,
   /**
   * xử lý thất bại
   */
   ProcessComplete: 35,

   FailReturn: 40,
   FailComplete: 45,
};
